import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { hasAdminPermissions } from 'app/helpers/browse/admin';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import AdminBrowseHomePage from './AdminBrowseHomePage';

// eslint-disable-next-line no-unused-vars
const AdminBrowseHomePageContainer = ({ basePageRoute }) => {
  const currentUser = useSelector(selectCurrentUser);

  const [state, setState] = useState({
    browseHomePages: [],
    isLoading: true
  });

  useEffect(() => {
    const storedBrowseHomePageIndex = JSON.parse(localStorage.getItem('browseHomePageIndex')) || {
      '1234': { browseHomePageId: '1234', title: 'First Browse Home Page' },
      '2468': { browseHomePageId: '2468', title: 'Second Browse Home Page' }
    };

    const browseHomePages = Object.keys(storedBrowseHomePageIndex).map(
      browseHomePageId => storedBrowseHomePageIndex[browseHomePageId]
    );

    setState(() => {
      return {
        browseHomePages,
        isLoading: false
      };
    });
  }, [setState]);

  const canViewPage = hasAdminPermissions(currentUser);
  if (!canViewPage) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  const { browseHomePages, isLoading } = state;
  if (isLoading) {
    return <p>Loading...</p>;
  }

  return <AdminBrowseHomePage browseHomePages={browseHomePages} />;
};

AdminBrowseHomePageContainer.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseHomePageContainer;
